import React from "react";

/**
 * BetweenUs brand mark — uses the official logo PNG (transparent).
 * Uses the 64px variant (6.7 KB) which is sharp for all current usage
 * (20–34 px). A larger 128px variant is available via srcset for 2×.
 */
export function BrandMark({ size = 36, className = "" }) {
    return (
        <img
            src="/brand/mark-64.png"
            srcSet="/brand/mark-64.png 1x, /brand/mark-128.png 2x"
            alt=""
            aria-hidden="true"
            width={size}
            height={size}
            loading="eager"
            decoding="async"
            fetchpriority="high"
            className={className}
            style={{ display: "inline-block", objectFit: "contain" }}
        />
    );
}

export function Wordmark({ className = "" }) {
    return (
        <span
            className={`font-display text-[20px] leading-none tracking-[-0.02em] text-[var(--brand-ink)] ${className}`}
        >
            Between<span className="text-[var(--brand-navy)]">Us</span>
        </span>
    );
}

export default BrandMark;
